/**
 * Translation: NL . Api
 * Note, also export in translations/{LANGUAGE}/index.js
 */
export default {
  'date.format': 'DD-MM-YYYY',
  'date.current.format': 'YYYY-MM-DD',
  'date.previous.month': 'Vorige maand',
  'date.next.month': 'Volgende maand',

  'date.month.january': 'januari',
  'date.month.february': 'februari',
  'date.month.march': 'maart',
  'date.month.april': 'april',
  'date.month.may': 'mei',
  'date.month.june': 'juni',
  'date.month.july': 'juli',
  'date.month.august': 'augustus',
  'date.month.september': 'september',
  'date.month.october': 'oktober',
  'date.month.november': 'november',
  'date.month.december': 'december',

  'date.day.sunday': 'zondag',
  'date.day.monday': 'maandag',
  'date.day.tuesday': 'dinsdag',
  'date.day.wednesday': 'woensdag',
  'date.day.thursday': 'donderdag',
  'date.day.friday': 'vrijdag',
  'date.day.saturdary': 'zaterdag',

  'date.day.sun': 'zo',
  'date.day.mon': 'ma',
  'date.day.tue': 'di',
  'date.day.wed': 'wo',
  'date.day.thu': 'do',
  'date.day.fri': 'vr',
  'date.day.sat': 'za',
};
